// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Tag/Tag.css
// module id = 1172
// module chunks = 0